import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// assets
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { cherriHoldingMobile } from "../../../assets/images/auth";
import MuiButtonSolid from "../../../components/Buttons/MuiButtons";
import { HtmlInput } from "../../../components/InputFields";

import { loginWithEmail, sendOtp } from "../../../apis";
import { Footer } from "../../../components";
import Navbar from "../../../components/Navbar";
import { setUser } from "../../../features/userSlice";
import { getDeviceId, setJwtTokens } from "../../../utils";
import { useAuthContext } from "../contexts/AuthContext";
import "./Password.css";

const EnterPassword = () => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [disableButton, setDisableButton] = useState(false);

  const navigate = useNavigate();
  const { phone } = useAuthContext();

  const handleLoginWithPassword = async () => {
    const deviceId = await getDeviceId();
    setDisableButton(true);
    const loginInfo = {
      email: phone,
      password,
      deviceId,
      deviceModel: "*",
    };

    const firebaseToken = localStorage.getItem("firebaseToken");
    if (firebaseToken) loginInfo.firebaseToken = firebaseToken;
    const response = await loginWithEmail(loginInfo);

    if (response?.data?.success) {
      toast.success("Login Successfull");
      dispatch(setUser(response.data.profile));
      setJwtTokens(response.data.tokenData);
      navigate("/dashboard");
    } else {
      toast.error("Password Incorrect");
    }
    setDisableButton(false);
  };

  const handleSendOtp = async () => {
    const response = await sendOtp({ phone, appSignature: "CHERRILEARN" });
    if (response.data.success) {
      localStorage.setItem(
        "CHERRILEARN_OTPSECRET",
        JSON.stringify(response.data.otpSecret)
      );
      navigate("/otplogin");
    }
  };

  return (
    <>
      <Navbar />

      <div className="password">
        <div className="passwordCotainer">
          <div className="passwordContainerLeft">
            <img
              className="cherriImage"
              src={cherriHoldingMobile}
              alt="cherri Holding Mobile"
            />
          </div>
          <div className="passwordContainerRight">
            <h1>Enter Your Password</h1>
            <HtmlInput
              margin="2rem 0 0 0"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
            />
            <MuiButtonSolid
              EndIcon={ArrowRightAltIcon}
              title="Continue"
              color="primary"
              variant="contained"
              fullWidth
              onClick={() => handleLoginWithPassword()}
              size="large"
              fontSize="1rem"
              disabled={disableButton}
            />
            <p>
              <strong>Forgot Password?</strong>
            </p>
            <MuiButtonSolid
              EndIcon={ArrowRightAltIcon}
              title="Login With Otp"
              color="primary"
              variant="outlined"
              fullWidth
              onClick={() => handleSendOtp()}
              size="large"
              fontSize="1rem"
              disabled={false}
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default EnterPassword;
